import { render, staticRenderFns } from "./ShoplistProduct.vue?vue&type=template&id=1f57aea8&"
import script from "./ShoplistProduct.vue?vue&type=script&lang=js&"
export * from "./ShoplistProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f57aea8')) {
      api.createRecord('1f57aea8', component.options)
    } else {
      api.reload('1f57aea8', component.options)
    }
    module.hot.accept("./ShoplistProduct.vue?vue&type=template&id=1f57aea8&", function () {
      api.rerender('1f57aea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/ShoplistProduct.vue"
export default component.exports